<template>
  <div>
      <el-row :gutter="10">
          <el-col :span="1.5">上次更新时间：</el-col>
          <el-col :span="8"><span>{{ last_time }}</span></el-col>
          <el-button  type="primary" size="mini" :disabled="disabled" @click="handleRefreshProduct()">{{ buttonText }}</el-button>
      </el-row>
  </div>
</template>

<script>
  import request from "../../api/request";
  import {setTimeout} from "timers";

  export default {
    name: "ProductUpdate",
    data() {
      return {
          last_time: '',
          buttonText: '更新产品',
          disabled: false
      };
    },
    created() {
        this.getUpdateLastTime();
    }, 
    methods: {
      getUpdateLastTime: function () {
        request.partner
          .post("product_process_info_get")
          .then((r) => {
              this.last_time = r.data.last_update_time;
          })
      },
      getUpdateStatus: function () {
          request.partner
              .post("product_process_info_get")
              .then((r) => {
                  if (r.data.last_process_status === 0) {
                      this.buttonText = "更新中"
                      this.disabled = true
                      setTimeout(() => {
                          this.getUpdateStatus()
                      }, 2000)
                  } else if (r.data.last_process_status === 1) {
                      this.$message.success("更新成功");
                      this.disabled = false
                      this.buttonText = "更新成功"
                      this.last_time = r.data.last_update_time;
                  } else {
                      this.buttonText = "更新产品"
                      this.disabled = false
                  }
              })
      },
      handleRefreshProduct: function() {
        request.partner
          .post("product_refresh")
          .then( () => {
             this.getUpdateStatus()
          })
        }
      }
  };
</script>
<style scoped>
  span {
      color: #909399;
  }
</style>
